import React, { FC } from 'react'
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

type Props = {
  featuredResource: any
}

export const FeaturedResource: FC<Props> = ({ featuredResource }) => (
  <div>
    {featuredResource.image && (
      <WrapperImage
        src={featuredResource.image}
        alt={featuredResource.imageAlt}
        width={540}
        height={544}
        threshold={650}
      />
    )}

    {featuredResource.category && (
      <Typography className="BlogFeaturedResource__Category" type="caption">
        {featuredResource.category}
      </Typography>
    )}

    {featuredResource.title && (
      <Typography className="BlogFeaturedResource__Title" type="header6">
        {featuredResource.title}
      </Typography>
    )}

    {featuredResource.body && (
      <Typography className="BlogFeaturedResource__Body font__inter" type="body">
        {featuredResource.body}
      </Typography>
    )}

    {featuredResource.ctaText && featuredResource.ctaUrl && (
      <Button
        icon={true}
        href={featuredResource.ctaUrl}
        text={featuredResource.ctaText}
        type="primary"
        size="small"
        theme={'dark'}
      />
    )}
  </div>
)
